import { render, staticRenderFns } from "./Direction.vue?vue&type=template&id=31332828"
import script from "./Direction.vue?vue&type=script&lang=js"
export * from "./Direction.vue?vue&type=script&lang=js"
import style0 from "./Direction.vue?vue&type=style&index=0&id=31332828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports